import React from "react";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Modal from "@src/sharedComponents/Modal/Modal";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TaskMessageModal.module.css";

interface TaskMessageModalProps {
  title: string;
  isOpen: boolean;
  onClose: {
    label: string;
    action: () => void;
    isDisabled?: boolean;
  };
  onConfirm: {
    label: string;
    action: () => void;
    isDisabled?: boolean;
  };
}

const TaskMessageModal: React.FC<
  React.PropsWithChildren<TaskMessageModalProps>
> = ({ children, title, isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose.action}
      modalStyle={{ maxWidth: 486 }}
    >
      <div className={styles.container}>
        <Text variant="title1">{title}</Text>

        {children}

        <div className={styles.actions}>
          <Button
            variant="outlined"
            size="medium"
            buttonType="primary"
            text={onClose.label}
            onClick={onClose.action}
            disabled={onClose.isDisabled}
          />

          <Button
            variant="contained"
            size="medium"
            buttonType="primary"
            text={onConfirm.label}
            onClick={onConfirm.action}
            disabled={onConfirm.isDisabled}
          />
        </div>
      </div>
    </Modal>
  );
};

export default TaskMessageModal;
